export function collectionToArray(collection) {
    return Array.prototype.slice.call(collection);
}
export function isPrintableKeyDown(e) {
    return e.key.length === 1;
}

//# sourceMappingURL=dom.js.map
